import { render } from "./cookie.vue?vue&type=template&id=50b08010"
import script from "./cookie.vue?vue&type=script&lang=js"
export * from "./cookie.vue?vue&type=script&lang=js"

import "./cookie.vue?vue&type=style&index=0&id=50b08010&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/cookie.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50b08010"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50b08010', __exports__)) {
    api.reload('50b08010', __exports__)
  }
  
  module.hot.accept("./cookie.vue?vue&type=template&id=50b08010", () => {
    api.rerender('50b08010', render)
  })

}


export default __exports__